import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import RetinaImage from 'src/components/RetinaImage';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import TestimonialsSection from 'src/components/TestimonialsSection';
import PaymentsDetailsSection from 'src/components/PaymentsDetailsSection';

import ImgWomanWorking from 'src/images/img-woman-working.jpg';
import ImgWomanWorking2x from 'src/images/img-woman-working@2x.jpg';
import ImgWomanWorking3x from 'src/images/img-woman-working@3x.jpg';
import IconPayments from 'src/images/icon-payments.png';
import IconPayments2x from 'src/images/icon-payments@2x.png';
import IconPayments3x from 'src/images/icon-payments@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconPayments, IconPayments2x, IconPayments3x]} />
              <div className='h1 mt-2'>Payments</div>
              <div className='h2 text-blue'>Take the pain out of parcel A/P.</div>
              <div styleName='message'>
                  Improve cash flow, radically simplify bookkeeping, and save
                  even more money when you outsource your shipping A/P to Galleon.
                  Great for shippers with complex shipping networks and meaningful
                  spend.
              </div>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgWomanWorking, ImgWomanWorking2x, ImgWomanWorking3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <PaymentsDetailsSection />
      <TestimonialsSection />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/payments.js